// extracted by mini-css-extract-plugin
export var container = "_3w-0";
export var disabled = "_3w-4";
export var fullWidth = "_3w-3";
export var lined = "_3w-1";
export var selected = "_3w-5";
export var tab = "_3w-2";